import { defineStore } from 'pinia'

export const useDepartmentStore = defineStore('department', {
    state: () => ({
        departmentListAll: [],
        departmentInfo: [],
        attendanceDepartment: null,
        selDepartmentInfo: null,
    }),

    actions: {
        // 更新某个表单
        updateDepartment(type, department) {
            this[`${type}`] = department
        },

        // 设置部门
        setDepartment(type, department) {
            this[`${type}`] = department
        },

        getDepartment(type) {
            return this[`${type}`]
        }
    },

    // 持久化（可选）：刷新页面数据不丢失
    persist: {
        enabled: true,
        strategies: [
            { storage: sessionStorage, paths: ['departmentInfo'] }
        ]
    }
})